import { useEffect } from 'react';

interface ToastProps {
  message: string;
  type?: 'success' | 'info' | 'warning' | 'error';
  onClose: () => void;
  duration?: number;
}

export default function Toast({ message, type = 'success', onClose, duration = 2500 }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  const colors = {
    success: 'bg-green-600',
    info: 'bg-babcock-navy-700',
    warning: 'bg-amber-600',
    error: 'bg-red-600',
  };

  const icons = {
    success: 'ri-check-line',
    info: 'ri-information-line',
    warning: 'ri-error-warning-line',
    error: 'ri-close-circle-line',
  };

  return (
    <div className="fixed top-6 right-6 z-[100] animate-in slide-in-from-top-2 fade-in duration-300">
      <div className={`${colors[type]} text-white px-5 py-3 rounded-lg shadow-lg flex items-center gap-2 text-sm font-medium`}>
        <i className={`${icons[type]}`}></i>
        <span>{message}</span>
      </div>
    </div>
  );
}
